export default () => ({
  initialized: false,
  init() {

    const videoThumbnails = document.querySelectorAll(".video-slider .video-thumb-container li");

    const videoModal = document.querySelector(".video-slider .video-modal");
    const videoPlayer = videoModal.querySelector("video");

    const videoClose = videoModal.querySelector('.close-video');

    function closeVideo() {
      videoPlayer.pause();
      videoPlayer.src = '';
      if(!videoModal.classList.contains("hidden"))
          videoModal.classList.add("hidden");
    }

    videoClose.addEventListener("click", function() {
      closeVideo();
    })

    for(let i = 0; i < videoThumbnails.length; i++) {
        videoThumbnails[i].addEventListener("click", function() {
            videoPlayer.src = this.getAttribute("data-video");
            videoModal.classList.remove("hidden");
            videoPlayer.play();
        });
    }

    videoModal.addEventListener("click", function(e) {
        if (!e.target.closest("video")) {
            closeVideo();
        }
    });
  }
});